export const COOKIE_PCUID = 'QUESTION_AI_PCUID';
export const COOKIE_UUID = 'QUESTION_AI_UUID';

export const LOCAL_STORAGE_LOGIN_CHANGE_NOTIFY = 'QUESTION_AI_LOGIN_CHANGE_NOTIFY';

// 登出通知
export const LOCAL_STORAGE_LOGOUT_NOTIFY = 'QUESTION_AI_LOGOUT_NOTIFY';
// 登录通知
export const LOCAL_STORAGE_LOGIN_NOTIFY = 'QUESTION_AI_LOGIN_CHANGE_NOTIFY';
export const LOCAL_STORAGE_USERINFO = 'QUESTION_AI_USERINFO';
